/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EducationConstraintSchemaMode } from './educationConstraintSchemaMode';

/**
 * Sub-doc-bound education constraint — see ExperienceConstraintSchema.
 */
export interface EducationConstraintSchema {
  school_name?: string | null;
  school_domain?: string | null;
  degree?: string | null;
  degrees?: string[] | null;
  major?: string | null;
  majors?: string[] | null;
  minors?: string[] | null;
  end_date_gte?: string | null;
  end_date_lte?: string | null;
  start_date_gte?: string | null;
  start_date_lte?: string | null;
  mode?: EducationConstraintSchemaMode;
}
